import React, { useState } from "react";
import { toast } from "sonner";
import { Crown, Check, LockKeyOpen } from "@phosphor-icons/react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { startCheckout } from "@/lib/api";

const PERKS = [
  "Verified exhibitor & attendee counts",
  "Top participating franchise brands",
  "Investment range & deal terms",
  "Direct organizer contacts",
  "Unlocks across every premium show",
];

export const PremiumModal = ({ open, onOpenChange, verified, onNeedVerify }) => {
  const [loading, setLoading] = useState(false);

  const handleUpgrade = async () => {
    if (!verified) {
      onOpenChange(false);
      onNeedVerify();
      return;
    }
    setLoading(true);
    try {
      const { checkout_url } = await startCheckout();
      window.location.href = checkout_url;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not start checkout");
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="premium-modal"
        className="overflow-hidden border-amber-400/25 bg-[#12141F] text-white sm:max-w-md"
      >
        <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-amber-400/10 blur-3xl" />
        <DialogHeader>
          <div className="mb-2 flex h-12 w-12 items-center justify-center rounded-xl bg-amber-400/15 ring-1 ring-amber-400/40">
            <Crown size={24} weight="fill" className="text-amber-300" />
          </div>
          <DialogTitle className="font-display text-2xl font-bold tracking-tight">
            Unlock Premium Access
          </DialogTitle>
          <DialogDescription className="text-slate-400">
            One-time payment. Instantly reveals exclusive deal intelligence across every premium listing.
          </DialogDescription>
        </DialogHeader>

        <div className="mt-2 flex items-baseline gap-2">
          <span className="font-display text-4xl font-extrabold text-white">$9.99</span>
          <span className="text-sm text-slate-500">one-time · lifetime access</span>
        </div>

        <ul className="mt-5 space-y-2.5">
          {PERKS.map((p) => (
            <li key={p} className="flex items-center gap-2.5 text-sm text-slate-300">
              <span className="flex h-5 w-5 items-center justify-center rounded-full bg-emerald-500/15">
                <Check size={13} weight="bold" className="text-emerald-400" />
              </span>
              {p}
            </li>
          ))}
        </ul>

        <button
          data-testid="premium-checkout-btn"
          onClick={handleUpgrade}
          disabled={loading}
          className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full bg-amber-400 px-6 py-3.5 text-sm font-bold text-black transition-colors duration-200 hover:bg-amber-300 disabled:opacity-60"
        >
          <LockKeyOpen size={18} weight="fill" />
          {loading ? "Redirecting to secure checkout…" : "Upgrade for $9.99"}
        </button>
        <p className="mt-3 text-center text-xs text-slate-500">
          Secure payment via Stripe · Test card 4242 4242 4242 4242
        </p>
      </DialogContent>
    </Dialog>
  );
};
